import type { Rink } from "../data/schema";

const DEG = Math.PI / 180;

// Maps rink metres <-> SVG pixels. Origin (0,0) is bottom-left in rink space;
// y increases toward the judges. SVG y grows downward, so ty flips it.
// Small px gutters on the left/top hold the grid coordinate labels (outside the rink).
export class RinkGeometry {
  readonly scale: number;
  readonly leftPx = 22; // gutter for row-number labels
  readonly topPx = 26; // gutter for JUDGES + column-letter labels
  readonly rightPx = 8;
  readonly bottomPx = 8;
  readonly width: number;
  readonly height: number;

  constructor(public rink: Rink, targetWidthPx = 1200) {
    this.scale = (targetWidthPx - this.leftPx - this.rightPx) / rink.lengthM;
    this.width = this.leftPx + rink.lengthM * this.scale + this.rightPx;
    this.height = this.topPx + rink.widthM * this.scale + this.bottomPx;
  }

  tx = (xM: number) => this.leftPx + xM * this.scale;
  ty = (yM: number) => this.topPx + (this.rink.widthM - yM) * this.scale;
  s = (m: number) => m * this.scale;

  // inverse (viewBox px -> metres), for the hover tooltip
  mx = (px: number) => (px - this.leftPx) / this.scale;
  my = (py: number) => this.rink.widthM - (py - this.topPx) / this.scale;

  headingVec(deg: number): [number, number] {
    return [Math.cos(deg * DEG), -Math.sin(deg * DEG)];
  }
}
